import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-white/10 mt-20" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row justify-between gap-6 text-sm text-zinc-500">
        <div>
          <div className="font-display text-lg font-bold text-white mb-2">Clipstar</div>
          <p className="max-w-xs">The universal AI clipping layer for campaign clippers. Campaign discovery is always free.</p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-2">
          <Link to="/pricing" className="hover:text-amber-400 transition-colors" data-testid="footer-pricing">Pricing</Link>
          <Link to="/privacy" className="hover:text-amber-400 transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-amber-400 transition-colors" data-testid="footer-terms">Terms of Service</Link>
          <Link to="/refunds" className="hover:text-amber-400 transition-colors" data-testid="footer-refunds">Billing &amp; Refunds</Link>
        </div>
      </div>
      <div className="border-t border-white/5 py-4 text-center text-xs text-zinc-600">
        © {new Date().getFullYear()} Clipstar. Clipstar is an independent tool and is not affiliated with any campaign platform.
      </div>
    </footer>
  );
}
